'use client';

import { motion, useReducedMotion } from 'framer-motion';

interface FadeInViewProps {
  delay?: number;
  children: React.ReactNode;
  className?: string;
}

export default function FadeInView({ delay = 0, children, className }: FadeInViewProps) {
  const reducedMotion = useReducedMotion();
  return (
    <motion.div
      initial={reducedMotion ? false : { opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
